import script from "./editPlayList.vue?vue&type=script&lang=ts&setup=true"
export * from "./editPlayList.vue?vue&type=script&lang=ts&setup=true"

import "./editPlayList.vue?vue&type=style&index=0&id=829cd026&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-829cd026"]])

export default __exports__